import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { initAnalytics, trackPageView } from './lib/analytics';
import { updateSeoTags } from './lib/seo';

export function App() {
  useEffect(() => {
    initAnalytics();
    updateSeoTags(router.state.location.pathname);
    trackPageView(router.state.location.pathname);

    const unsubscribe = router.subscribe((state) => {
      updateSeoTags(state.location.pathname);
      trackPageView(state.location.pathname);
    });

    return unsubscribe;
  }, []);

  return <RouterProvider router={router} />;
}
